import Header from "./modules/Header";
import VideoParallax from "./modules/VideoParallax";
import VariantSizeSelector from "./modules/VariantRetainers";
import VariantCode from "./modules/VariantCode";
// import SelloutVariants from "./modules/VariantState";
import HideFooterBlocks from "./modules/HideFooterBlocks";
import InstagramFeed from "./Instagram";
import ReadMoreRTE from "./modules/ReadMoreRTE";
import TreeCounter from "./modules/TreeCounterComponent";
import TentSelector from "./modules/TentSelector";
import VariantVisibilityToggle from "./modules/VariantVisibilityToggle";
import './modules/LazyBackground';
import "lite-youtube-embed";

new Header();
new VideoParallax();
new VariantSizeSelector();
new VariantCode();
// new SelloutVariants();
new HideFooterBlocks();
new InstagramFeed();
new ReadMoreRTE();
new TreeCounter();
new TentSelector();
new VariantVisibilityToggle();
